export default "__VITE_ASSET__CtL_xyt___"